import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import HomeComponent from '../presentation/Home';
import * as dashboardActions from '../../actions/home';

function mapStateToProps(state) {
    return {
        home: state.home,
        territories : state.territories,
        coordinations : state.coordinations,
        users : state.users,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...dashboardActions}, dispatch);
}

class Home extends React.Component {

    componentWillMount() {
        this.props.fetchPerformanceReport();
    }

    render() {
        return (
            <HomeComponent {...this.props} />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Home.jsx
 **/